<template>
  <v-card
    tile
    flat
    outlined
    class="memolyCardSkeletons">
    <v-skeleton-loader
      type="image"
      :max-height="height"
      tile />

    <v-skeleton-loader
      v-if="isTwoLine"
      type="list-item-two-line" />
    <v-skeleton-loader
      v-else
      type="list-item-three-line" />
  </v-card>
</template>

<script>
export default {
  props: {
    isTwoLine: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      height: 0,
    };
  },
  mounted: function() {
    let skeletons = document.getElementsByClassName('memolyCardSkeletons')[0];
    this.height = skeletons.offsetWidth - 2;
  },
};
</script>
